import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/molecules/Header/Header";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate("/payments"); // Navigate back to payment page
  };

  const handleHome = () => {
    navigate("/"); // Navigate to homepage
  };

  return (
     <>
          <Header />
          <Container>
    <div className="payment-failed-container">
      <div className="payment-failed-icon">❌</div>
      <h1 className="payment-failed-title">Payment Failed</h1>
      <p className="payment-failed-message">
        Unfortunately, your payment could not be processed. Please try again or
        contact support if the problem persists.
      </p>
      <div className="payment-failed-buttons">
        <button className="retry-button" onClick={handleRetry}>
          Retry Payment
        </button>
        <button className="home-button" onClick={handleHome}>
          Go to Home
        </button>
      </div>
    </div>
    </Container>
      <Footer />
    </>
  );
};

export default PaymentFailed;
